import type { FeedNotificationOptions } from '~/stores/notificationFeed'

/**
 * What the "Copy list" button puts on the clipboard: one identifier per line,
 * ready to paste into a search or a spreadsheet. `undefined` for a single
 * identifier, which is already on screen and not worth a button.
 */
export function copyListText(identifiers: string[]): string | undefined {
  return identifiers.length > 1 ? identifiers.join('\n') : undefined
}

/**
 * A notification that names what it acted on. Every identifier goes in the
 * message — the feed collapses a long one behind "Show all" rather than us
 * dropping the tail, so nothing becomes unreachable.
 */
export function identifierListNotification(
  title: string,
  identifiers: string[]
): FeedNotificationOptions {
  return {
    title,
    message: identifiers.join(', '),
    copyText: copyListText(identifiers),
  }
}
